import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import QRMenu from './QRMenu';
import QRMenuAksam from './QRMenuAksam';
import { ThemeProvider } from './ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<QRMenu />} />
          <Route path="/aksam" element={<QRMenuAksam />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
